let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ngvh")).then(() => parcelRequire('d60rx'));